import { render } from "./FooterPart.vue?vue&type=template&id=7a8476c1"
const script = {}

import "./FooterPart.vue?vue&type=style&index=0&id=7a8476c1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__